import React from "react";
import moment from "moment";
import "moment/locale/es";
import { withTranslation } from "react-i18next";
import {
  LocalStorageService,
  UserService,
  ClientDocument,
  ContractorService,
  CategoryService,
  ClientService
} from "../../../services";
import { DocumentsToRequireView } from "../../views";
import { DocumentsToRequireValidator } from "../../../validators";
import { convertToStandarDate, getNavigatorTimezone } from "../../../utils";

class DocumentsToRequireAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showLoadingRequesting: false,
      showErrorRequesting: false,
      showCompletedRequesting: false,
      messageError: '',
      user: {},
      documents: [],
      token: "",
      shouldRefresh: false,
      showDialogYesNo: false,
      dataItemUser: {},
      personTypes: [],
      typeDocuments: [],
      preferenceValue: false,
      selectedFile: null,
      selectedFileName: '',
      errorFile: false,
      selectedFileBase64: "",
      colorBorderContainer: "gray",
      newOptions: []
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  UserService = new UserService(this.url);
  contractorService = new ContractorService(this.url)
  ClientDocument = new ClientDocument(this.url);
  categoryService = new CategoryService(this.url);
  clientService = new ClientService(this.url)
  validators = DocumentsToRequireValidator(this.props.t);
  timezone = getNavigatorTimezone()
  goBackRoute = '/configuration'
  language = 'es'
  ENV = process.env

  async componentDidMount() {
    this.toggleLoadingView(true)
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let user = this.localStorageService.getLocalStorageItem("user");
    const localStorageService = new LocalStorageService();

    const preferredLanguage = localStorageService.getLocalStorageItem("preferredLanguage")
    const language = preferredLanguage || "es"
    this.language = language
    moment.locale(language);

    let clientID = user.userMetaData.userMifirma.clientId;
    try {
      let documentsData = await this.ClientDocument.getClientDocumentA3Cloud(
        clientID,
        this.token
      );

      let documents = documentsData.data.data;

      const allDocuments = documents.map((documento) => {
        let convertDate = convertToStandarDate(documento.updatedDateBD, language)
        const standarDate = (convertDate !== 'invalid date') ? convertDate : documento.updatedDate
        documento.newUpdatedDate = `${this.props.t("documentsToRequire.grid.modifiedOn")} ${standarDate}`;
        if (documento.clientDocumentTypeRequest === null && documento.clientDocumentTypeRequestId === null) {
          documento.clientDocumentTypeRequestId = 0
          documento.clientDocumentTypeRequest = { name: 'Sin definir' }
        }

        return documento;
      });

      this.getPersonType()
      this.getDocumentTypes()
      this.getPreferences()
      this.getAllClientDocumentTypeRequest()

      this.setState({
        documents: allDocuments,
        user,
        token: this.token,
      });
    } catch (error) {
      this.props.history.push(this.goBackRoute);
      this.toggleLoadingView(false)
    }
  }

  toggleLoadingView = (value) => {
    this.setState({
      loading: value
    })
  }

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  toggleErrorRequestingFalse = () => {
    this.setState({
      showErrorRequesting: false
    })
  }

  toggleErrorRequesting = (message, time, sendInbox, path) => {
    let sendTo = (path && path !== '') ? path : "/"
    this.setState({
      showErrorRequesting: true,
      messageError: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showErrorRequesting: false,
        })
        if (sendInbox) {
          const locationState = this.props.location.state
          if (locationState && locationState.from) {
            this.props.history.push({
              pathname: locationState.from,
              state: locationState
            })
          } else {
            this.props.history.push(sendTo)
          }
        }
      }, time || 4000)
    })
  }

  toggleCompletedRequesting = (
    value,
    message,
    documents
  ) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: "",
            documents
          });
          // funcion()
        }, 4000);
      }
    );
  };

  //DialogYesNoHLpure funtion to show o not show
  toggleDialogYesNo = (dataItem, value) => {
    this.setState({
      dataItemUser: dataItem,
      showDialogYesNo: value,
    });
  };

  getPersonType = async () => {
    try {
      let contractorPersonType = await this.contractorService.getPersonTypeByKey('documentType', this.token)
      if (contractorPersonType && contractorPersonType.data && Number(contractorPersonType.statusCode) === 200) {
        let personTypes = contractorPersonType.data

        personTypes.sort((a, b) => a.id - b.id)
        personTypes.map((type) => {
          type.personType = `${this.props.t(`documentsToRequire.document.type.key.${type.key}`)}`;
          type.name = type.key
          return type
        })

        const placeholderFilter = {
          name: this.props.t("documentsToRequire.document.type.key.all"),
          personType: this.props.t("documentsToRequire.document.type.key.all")
        }
        personTypes.unshift(placeholderFilter);
        this.setState({
          personTypes,
          loading: false
        })
      } else {
        this.props.history.push(this.goBackRoute);
        this.setState({
          loading: false,
        });
      }
    } catch (error) {
      this.props.history.push(this.goBackRoute);
      this.setState({
        loading: false,
      });
    }
  }

  getDocumentTypes = async () => {
    try {
      const responseDocType = await this.categoryService.getTypeDocuments(this.token, 'Documento');
      if (responseDocType.statusCode == 200 && responseDocType.data) {
        let typeDocumentOptions = responseDocType.data;
        typeDocumentOptions.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

        // Filter only "Documento" infoType
        const onlyTypeDocument = typeDocumentOptions.filter(td => { return td.infoType === this.ENV.REACT_APP_DIGITAL_VAULT_DOCUMENT })

        this.setState({
          typeDocuments: onlyTypeDocument
        })
      } else {
        this.props.history.push(this.goBackRoute);
        this.setState({
          loading: false,
        });
      }
    } catch (error) {
      this.props.history.push(this.goBackRoute);
      this.setState({
        loading: false,
      });
    }
  }

  getPreferences = async () => {
    try {
      let preferences = await this.clientService.getClientPreferences(this.token, this.timezone);
      if (preferences && preferences.data && Number(preferences.statusCode) === 200) {
        let preferenceProcedureUser = preferences.data.find((preference) => preference.preferenceName === process.env.REACT_APP_PREFERENCE_PROCEDURES_CONTROL)
        let preferenceValue = (preferenceProcedureUser) ? preferenceProcedureUser.booleanValue : false
        this.setState({
          preferenceValue
        })
      } else {
        this.props.history.push(this.goBackRoute);
        this.setState({
          loading: false,
        });
      }
    } catch (error) {
      this.props.history.push(this.goBackRoute);
      this.setState({
        loading: false,
      });
    }
  }

  handleFile = async (e) => {
    if (!e || !e.target || !e.target.files || e.target.files.length === 0) return
    this.setState({
      selectedFile: e.target.files[0],
      selectedFileName: e.target.files[0].name,
      errorFile: false,
      colorBorderContainer: "green",
    });

    // Upload the base64 in the state
    let fileBase64 = await this.pdfToBase64(e.target.files[0]);
    let pdfBase64 = fileBase64.split(",")[1];
    this.setState({ selectedFileBase64: pdfBase64 });
  };

  handleDeleteFile = (e) => {
    this.setState({
      selectedFile: null,
      errorFile: false,
      selectedFileBase64: "",
      colorBorderContainer: "gray",
    });
    return true;
  };

  pdfToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    }
    );

  getAllClientDocumentTypeRequest = async () => {
    try {
      let clientDocumentsTypes = await this.ClientDocument.getAllClientDocumentTypeRequest(this.token)
      if (!clientDocumentsTypes || !clientDocumentsTypes.data || Number(clientDocumentsTypes.statusCode) !== 200) throw new Error('Ocurrió un error al consultar la clasficación de documentos')

      let typesClientDocuements = clientDocumentsTypes.data.map((type) => {
        type.name = this.props.t(`documentsToRequire.typeRequest.name.${type.name}`)
        type.value = type.id
        return type
      })

      this.setState({
        newOptions: typesClientDocuements
      })
    } catch (error) {
      this.props.history.push(this.goBackRoute);
      this.setState({
        loading: false,
      });
    }
  }


  render() {
    return (
      <DocumentsToRequireView
        {...this.state}
        history={this.props.history}
        validators={this.validators}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleErrorRequestingFalse={this.toggleErrorRequestingFalse}
        toggleDialogYesNo={this.toggleDialogYesNo}
        handleDeleteFile={this.handleDeleteFile}
        handleFile={this.handleFile}
        goBackRoute={this.goBackRoute}
        language={this.language}
      />
    );
  }
}

export default withTranslation()(DocumentsToRequireAction);
